import { render, staticRenderFns } from "./subscribe.vue?vue&type=template&id=5f916d82&scoped=true"
import script from "./subscribe.vue?vue&type=script&lang=js"
export * from "./subscribe.vue?vue&type=script&lang=js"
import style0 from "./subscribe.vue?vue&type=style&index=0&id=5f916d82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f916d82",
  null
  
)

export default component.exports